// Helper function to generate full URL from image ID
function getImageUrl(imageId) {
    return `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/${imageId}/public`;
  }
function getImageThumbnail(imageId) {
    return `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/${imageId}/thumbnail`;
  }
  
  // Exported array with id, pageId, and dynamically composed URLs
export const graphic_data = [
  {
    "id": 517,
    "pageId": "518",
    "imageId": "edfa691f-8684-4522-c9b4-5099604cf700",
    "description": "Veen Diagram"
  },
  {
    "id": 518,
    "pageId": "519",
    "imageId": "1359a8db-ec1e-4b6a-1dd1-17af4fda9700",
    "description": "Tres escenas",
    "edit_image_id": "0b653fb1-b141-4e86-5c4c-7161c2ddee00"
  },
  {
    "id": 519,
    "pageId": "520",
    "imageId": "e61c7098-e3d7-49d7-4764-25c54e430800",
    "description": "Conectados",
    "edit_image_id": "aba02ed4-fc9b-480d-e9ec-c70c95674000",
  },
  {
    "id": 520,
    "pageId": "521",
    "imageId": "5021f3a9-9339-4328-43c7-6029293c4800",
    "description": "Semejanzas, deferencias, conclusiones"
  },
  {
    "id": 521,
    "pageId": "522",
    "imageId": "3efee510-1722-44b7-dfa5-a9bb86570600",
    "description": "Ficha del personaje",
    "edit_image_id": "c52cf4ee-8cb5-4d23-9657-cd1c2d059900"
  },
  {
    "id": 522,
    "pageId": "523",
    "imageId": "8eee5d9d-740f-409a-5899-f2dd6b33ba00",
    "description": "Imágenes sensoriales"
  },
  {
    "id": 523,
    "pageId": "524",
    "imageId": "0d8e9429-66af-46ce-2369-8c0ff44d9100",
    "description": "¡A escuchar!",
    "edit_image_id": "2121e095-1870-40be-5466-5db0ff166200"
  },
  {
    "id": 524,
    "pageId": "525",
    "imageId": "d88c4cda-9109-4f29-a11a-e49f12e99b00",
    "description": "Analizando un cuento",
    "edit_image_id": "24c3b1cd-56e9-4592-8707-e97a0f1b4a00"
  },
  {
    "id": 525,
    "pageId": "526",
    "imageId": "adc635ab-10ec-4a65-87ed-5be571789800",
    "description": "Contribuciones al clímax",
    "edit_image_id": "c805dac8-3f5f-4ef5-e7cf-31bb5b89a600"
  },
  {
    "id": 526,
    "pageId": "527",
    "imageId": "6c92dab6-ab20-4655-1f23-30946d2c4100",
    "description": "Las partes del cuento",
    "edit_image_id": "7b957b71-736d-43fa-9131-202e55557c00"
  },
  {
    "id": 527,
    "pageId": "528",
    "imageId": "9bfa228c-7bdf-4cb7-db18-81cce9de8400",
    "description": "Convéncelos",
    "edit_image_id": "fdca465c-28de-4f52-183e-6782d9121300"
  },
  {
    "id": 528,
    "pageId": "529",
    "imageId": "6323a932-45d6-49df-325f-92fc4ace6500",
    "description": "Detectives de caracterización",
    "edit_image_id": "f928b1cd-1fa3-407f-db35-009971710700"
  },
  {
    "id": 529,
    "pageId": "530",
    "imageId": "afc2f04b-9fac-44d0-0f4f-d236e3f83d00",
    "description": "En los zapatos del autor",
    "edit_image_id": "89ffe21a-932d-4ae6-6c9f-d438e8409b00"
  },
  {
    "id": 530,
    "pageId": "531",
    "imageId": "e3108731-18e2-4234-8e45-d8c014a5d400",
    "description": "Figuras literarias",
    "edit_image_id": "04dc5766-0b97-414a-e621-86034431ad00"
  },
  {
    "id": 531,
    "pageId": "532",
    "imageId": "841a9d4d-be06-4b97-2449-7119934f4200",
    "description": "Ingreso de palabras nuevas",
    "edit_image_id": "1fd0af5c-594b-4623-8f70-b8db025a5600"
  },
  {
    "id": 532,
    "pageId": "533",
    "imageId": "c8c31213-66a2-4e1a-c9b9-792b79e2b800",
    "description": "Interconectados",
    "edit_image_id": "efb88d1a-8e7c-49e8-ecb7-4dedc535fb00"
  },
  {
    "id": 533,
    "pageId": "534",
    "imageId": "f193082b-3e49-4f0c-9b84-8e679480b100",
    "description": "Interpretación poética",
    "edit_image_id": "e02b6ca1-fc4e-4986-2856-56034f9aad00"
  },
  {
    "id": 534,
    "pageId": "535",
    "imageId": "e40fdee2-6dff-4821-88ee-2b114d98c200",
    "description": "Interrogantes",
    "edit_image_id": "9f23f423-8e7d-40ac-8775-f9a2d4c5e000"
  },
  {
    "id": 535,
    "pageId": "536",
    "imageId": "168f75fc-28cb-4257-5650-82a4ff202800",
    "description": "Mente abierta",
    "edit_image_id": "9852b73a-1ece-4d3d-6713-cb6ee9fa9100"
  },
  {
    "id": 536,
    "pageId": "537",
    "imageId": "58ffb731-5bbb-4132-0679-330078fd9800",
    "description": "Palabras valiosas",
    "edit_image_id": "c87b61c4-2a1e-4c54-d10c-0b653f386000"
  },
  {
    "id": 537,
    "pageId": "538",
    "imageId": "1d980d3c-3a1e-4665-b691-2e9fe5f92100",
    "description": "Predicciones",
    "edit_image_id": "a9b19e93-691e-4b17-3b96-a6cc27626000"
  },
  {
    "id": 538,
    "pageId": "539",
    "imageId": "12e95b0d-f3e9-4a07-cb95-a6ec62e33b00",
    "description": "Resumen de texto expositivo",
    "edit_image_id": "f23b21e6-b012-4ee9-aed9-9e456c44c900"
  },
  {
    "id": 539,
    "pageId": "540",
    "imageId": "85e0b523-8e9d-49de-5d85-e9f77bcb5d00",
    "description": "Resumen de texto narrativo",
    "edit_image_id": "ffb665aa-6668-414a-d6da-52c6cb0f8300"
  },
  {
    "id": 540,
    "pageId": "541",
    "imageId": "c1117e41-c72c-46f7-f4b6-9cb6d614f400",
    "description": "Semejanzas, diferencias, conclusiones",
    "edit_image_id": "fbce5ef1-3093-4cb9-c512-45de876e1100"
  },
  {
    "id": 541,
    "pageId": "542",
    "imageId": "b8388781-e517-4f65-5b45-57fd3fb3b600",
    "description": "Soy bilingüe",
    "edit_image_id": "b7fc51e3-4ea8-4c75-7afa-7bbbdf94ba00"
  },
  {
    "id": 542,
    "pageId": "543",
    "imageId": "919a2bf7-e0d9-4e6f-2041-2a14139c5100",
    "description": "Una es suficiente",
    "edit_image_id": "cb66ea29-bb9e-4f7c-9264-c1580eb75000"
  },
  {
    "id": 543,
    "pageId": "544",
    "imageId": "aac9df48-68b9-4701-b2d7-020a8433d500",
    "description": "Viñetas del cuento"
  },
  {
    "id": 544,
    "pageId": "545",
    "imageId": "d8f4e5b8-bd90-43f4-c0b7-cb5172e03500",
    "description": "¿Y el tono?",
    "edit_image_id": "938caf76-44cc-41a5-a1b4-6ba5becb0400"
  },
  {
    "id": 545,
    "pageId": "546",
    "imageId": "76c63de9-becc-4d00-b4ce-2d479f8d3c00",
    "description": "T chart",
    "edit_image_id": "8faec7df-d4e4-4ace-6b16-6e090269b600"
  },
  {
    "id": 546,
    "pageId": "547",
    "imageId": "1c62a757-04db-4734-17f0-93392ed8d200",
    "description": "Cornell notes",
    "edit_image_id": "7d8feba8-f1c9-4ea3-e56c-2228ada64300"
  }
].map(({ id, pageId, imageId ,description, edit_image_id }) => ({
    id,
    pageId,
    src: getImageUrl(imageId),
    thumbnail: getImageThumbnail(imageId),
    description,
    edit_image_src: getImageUrl(edit_image_id || imageId),
    edit_image_thumbnail: getImageThumbnail(edit_image_id || imageId),
  }));

export const graphic_activity = [
  {
    "id": "cc237dd8-ed49-476d-baad-c1a9684b9fsd",
    "bookId": 7,
    "chapter": 7,
    "displayName": "VENN DIAGRAM",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "a"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "short 3-5 word title",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "veenDiagram1"
      },
      {
        "placeholder": "short 3-5 word title",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "veenDiagram2"
      },
      {
        "placeholder": "4-5 bullet points each with 3-7 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": true,
        "class_name": "veenDiagram3"
      },
      {
        "placeholder": "4-5 bullet points each with 3-7 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": true,
        "class_name": "veenDiagram4"
      },
      {
        "placeholder": "4-5 bullet points each with 3-7 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": true,
        "class_name": "veenDiagram5"
      }
    ],
    "assignment_page": 518,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "cc237dd8-ed49-476d-baad-c1a9684b9f8c",
    "bookId": 7,
    "chapter": 7,
    "displayName": "TRES ESCENAS",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "a"
      }
    ],
    "colorCode": "",
    "bookDescription": null,
    "redirectTo": null,
    "level": "",
    "type": "",
    "createdBy": "system",
    "cloneId": null,
    "category": "",
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "short 3-5 word title",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tresEscenas1"
      },
      {
        "placeholder": "short 3-5 word title",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tresEscenas2"
      },
      {
        "placeholder": "short 3-5 word title",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tresEscenas3"
      },
      {
        "placeholder": "drawing",
        "input_type": "image",
        "text_length": null,
        "class_name": "tresEscenas4"
      },
      {
        "placeholder": "drawing",
        "input_type": "image",
        "text_length": null,
        "class_name": "tresEscenas5"
      },
      {
        "placeholder": "drawing",
        "input_type": "image",
        "text_length": null,
        "class_name": "tresEscenas6"
      },
      {
        "placeholder": "sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": true,
        "class_name": "tresEscenas7"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Después de leer el texto dibuja y dales un título a las escenas más importantes. En la parte de abajo escribe un pequeño resumen que vincule tus tres escenas. No olvides usar por lo menos tres palabras de transición.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tresEscenasInstruction"

      }
    ],
    "assignment_page": 519,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "b7121056-e942-4885-9223-212f99b67e11",
    "bookId": 7,
    "chapter": 7,
    "displayName": "CONECTADOS",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "#1"
      }
    ],
    "colorCode": "",
    "bookDescription": null,
    "redirectTo": null,
    "level": "",
    "type": "",
    "createdBy": "system",
    "cloneId": null,
    "category": "",
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "one sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "conectados-input1"
      },
      {
        "placeholder": "one sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "conectados-input2"
      },
      {
        "placeholder": "one sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "conectados-input3"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Al leer el artículo saca las 3 ideas más importantes y escribe una oración donde las relaciones.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "conectadosInstruction"
      }
    ],
    "assignment_page": 520,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "74bec716-64bf-49b9-84ae-f24dd078f3ba",
    "bookId": 7,
    "chapter": 7,
    "displayName": "TEMA, SUBTEMA YDETALLES",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": "",
    "bookDescription": null,
    "redirectTo": null,
    "level": "",
    "type": "",
    "createdBy": "system",
    "cloneId": null,
    "category": "",
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "semejanzas-input1"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "semejanzas-input2"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "semejanzas-input3"
      },
      {
        "placeholder": "2-3 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzas-input4"
      },
      {
        "placeholder": "2-3 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzas-input5"
      },
      {
        "placeholder": "2-3 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzas-input6"
      },
      {
        "placeholder": "2-3 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzas-input7"
      }
    ],
    "label_position": [
    ],
    "assignment_page": 521,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "4bd4e7c1-e399-4e1e-b41d-c32e210d1277",
    "bookId": 7,
    "chapter": 7,
    "displayName": "FICHA DEL PERSONAJE",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": "",
    "bookDescription": null,
    "redirectTo": null,
    "level": "",
    "type": "",
    "createdBy": "system",
    "cloneId": null,
    "category": "",
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "max_height": "15%",
        "min_height": "15%",
        "class_name": "ficha-input1"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "max_height": "15%",
        "min_height": "15%",
        "class_name": "ficha-input2"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "max_height": "15%",
        "min_height": "15%",
        "class_name": "ficha-input3"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "max_height": "15%",
        "min_height": "15%",
        "class_name": "ficha-input4"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "max_height": "15%",
        "min_height": "15%",
        "class_name": "ficha-input5"
      },
      {
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "",
        "bottom_border": false,
        "class_name": "ficha-input6"
      }
    ],

    label_position: [
      {
        "placeholder": "Descripción del personalidad",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ficha-label-1"
      },
      {
        "placeholder": "¿Qué conflicto encara?",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ficha-label-2"
      },
      {
        "placeholder": "Entorno cultural",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ficha-label-3"
      },
      {
        "placeholder": "Entorno social",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ficha-label-4"
      },
      {
        "placeholder": "Descripción fisica",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ficha-label-5"
      },
      {
        "placeholder": "Retrado",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ficha-label-6"
      },
    ],
    "assignment_page": 522,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "f7697661-7251-465d-b04e-01ac6b0fa21b",
    "bookId": 7,
    "chapter": 7,
    "displayName": "Mis ejemplos.",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "Algo que escuchas"
      }
    ],
    "colorCode": "",
    "bookDescription": null,
    "redirectTo": null,
    "level": "",
    "type": "",
    "createdBy": "system",
    "cloneId": null,
    "category": "",
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "width": "0.245",
        "left": "0.245",
        "top": "0.24",
        "height": "0.14",
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "one_line",
        "bottom_border": false
      },
      {
        "width": "0.245",
        "left": "0.55",
        "top": "0.24",
        "height": "0.14",
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "one_line",
        "bottom_border": false
      },
      {
        "width": "0.245",
        "left": "0.24",
        "top": "0.50",
        "height": "0.14",
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "one_line",
        "bottom_border": false
      },
      {
        "width": "0.245",
        "left": "0.57",
        "top": "0.50",
        "height": "0.14",
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "one_line",
        "bottom_border": false
      },
      {
        "width": "0.245",
        "left": "0.38",
        "top": "0.73",
        "height": "0.14",
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "one_line",
        "bottom_border": false
      }
    ],
    "assignment_page": 523,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab2d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "¡ A ESCUCHAR!",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": "",
    "bookDescription": null,
    "redirectTo": null,
    "level": "",
    "type": "",
    "createdBy": "system",
    "cloneId": null,
    "category": "",
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "3-5 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "aEscuchar1"
      },
      {
        "placeholder": "3-5 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "aEscuchar2"
      },
      {
        "placeholder": "3-5 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "aEscuchar3"
      }
    ],
    "label_position": [
      {
        "placeholder": `Antes de leer
• Lee el título del audio y piensa en lo que sabes del tema.
• Haz una predicción de lo que aprenderás.
• Escribe algo que quieres aprender.`,
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "aEscucharInstruction1"
      },
      {
        "placeholder": `Al escuchar
• Toma nota de los puntos más importantes del audio. `,
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "aEscucharInstruction2"
      },
      {
        "placeholder": ` Después de escuchar
• Define la postura del ponente/audio, canción, reportaje o entrevista.
• ¿Qué te gustó más del audio?
• ¿Cuál es tu reacción? `,
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "aEscucharInstruction3"
      }
    ],
    "assignment_page": 524,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab3d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "ANALIZANDO UN CUENTO",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-input1"
      },
      {
        "placeholder": "3-5 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input2"
      },
      {
        "placeholder": "3-5 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input3"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input4"
      },
      {
        "placeholder": "3-5 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input5"
      },
      {
        "placeholder": "3-5 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input6"
      },
      {
        "placeholder": "3-5 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input7"
      },
      {
        "placeholder": "3-5 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input8"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input9"
      },
      {
        "placeholder": "3-5 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "analizando-input10"
      }
    ],
    "label_position": [
      {
        "placeholder": "Tema",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-1"
      },
      {
        "placeholder": "Ambiente",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-2"
      },
      {
        "placeholder": "Personajes principales",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-3"
      },
      {
        "placeholder": "Punto de vista",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-4"
      },
      {
        "placeholder": "Simbolismo",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-5"
      },
      {
        "placeholder": "Elementos literarios",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-6"
      },
      {
        "placeholder": "Conflicto literario",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-7"
      },
      {
        "placeholder": "Caracterización",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-8"
      },
      {
        "placeholder": "Conexión con tu vida",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-9"
      },
      {
        "placeholder": "Autor",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "analizando-title-10"
      },
    ],
    "assignment_page": 525,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab4d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "CONTRIBUCIONES AL CLIMAX",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "short 3-5 line instruction",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribucionesInstruction"
      },
      {
        "placeholder": "sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribuciones-input1"
      },
      {
        "placeholder": "sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribuciones-input2"
      },
      {
        "placeholder": "sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribuciones-input3"
      },
      {
        "placeholder": "sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribuciones-input4"
      },
      {
        "placeholder": "sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribuciones-input5"
      },
      {
        "placeholder": "sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribuciones-input6"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Recuerda que el clímax es el momento donde la obra alcanza su mayor tensión. Identifica el clímax y escribe en orden los elementos que han causado ese momento tan importante.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "contribucionesInstruction"
      },
    ],
    "assignment_page": 526,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "LASPARTES DEL CUENTO",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input1"
      },
      {
        "placeholder": "3-4 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input2"
      },
      {
        "placeholder": "3-4 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input3"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input4"
      },
      {
        "placeholder": "3-4 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input5"
      },
      {
        "placeholder": "3-4 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input6"
      },
      {
        "placeholder": "3-4 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input7"
      },
      {
        "placeholder": "3-4 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input8"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input9"
      },
      {
        "placeholder": "3-4 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-input10"
      }
    ],
    "label_position": [
      {
        "placeholder": "Tema",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-header-1"
      },
      {
        "placeholder": "Definición",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-header-2"
      },
      {
        "placeholder": "Ejemplos textuales",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-header-3"
      },
      {
        "placeholder": "Introducción",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-row-1"
      },
      {
        "placeholder": "Desarrollo",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-row-2"
      },
      {
        "placeholder": "Clímax",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-row-3"
      },
      {
        "placeholder": "Desenlace",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-row-4"
      },
      {
        "placeholder": "Resolución",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "laspartes-row-5"
      }
    ],
    "assignment_page": 527,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab6d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "CONVÉNCELOS",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-input1"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-input2"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-input3"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-input4"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-input5"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-input6"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Vamos a trabajar la persuasión. Sigue las pautas para ver qué tan convincente es tu 'pitch'.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelosInstruction"
      },
      {
        "placeholder": "Tema",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name":"convencelos-header"
      },
      {
        "placeholder": "Anzuelo",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-row-title-1"
      },

      {
        "placeholder": "Tesis",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-row-title-2"
      },
      {
        "placeholder": "Tesismonio o detalles concretos",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-row-title-3"
      },
      {
        "placeholder": "Humor",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-row-title-4"
      },
      {
        "placeholder": "Llamado o acción",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "convencelos-row-title-5"
      },

    ],
    "assignment_page": 528,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab7d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "DETECTIVES DE CARACTERIZACIÓN",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "detective-input1"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "detective-input2"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input3"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input4"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input5"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input6"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input7"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input8"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input9"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input10"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input11"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input12"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input13"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-input14"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Recuerda que nosotros llegamos a conocer la personalidad y rasgos físicos por medio de información que se nos da en la lectura. Existen dos tipos de caracterización: la directa y la indirecta. La caracterización directa sucede cuando el narrador nos da descripciones breves del personaje en la lectura. La caracterización indirecta presenta al personaje, sus cualidades y defectos por medio de sus actos y el diálogo en el texto.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detectiveInstruction"
      },
      {
        "placeholder": "Tema",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "detective-header-1"
      },
      {
        "placeholder": "Personaje",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "detective-header-2"
      },
      {
        "placeholder": "Cita del texto",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-column-title-1"
      },
      {
        "placeholder": "Tipo de caracterización",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-column-title-2"
      },
      {
        "placeholder": "¿Qué aprendiste como lector sobre el personaje?",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "detective-column-title-3"
      },

    ],
    "assignment_page": 529,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab8d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "EN LOS ZAPATOS DEL AUTOR",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "enLosZapatosDelAutor1"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "enLosZapatosDelAutor2"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "enLosZapatosDelAutor3"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "enLosZapatosDelAutor4"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "image",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "enLosZapatosDelAutor5"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Después de haber leído la biografía del autor, imagina que tú eres él/ella y describe los eventos más importantes que han destacado de tu vida (o sea la vida del autor). Después en el centro haz una ilustración del autor.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "enLosZapatosDelAutorInstruction"
      },
    ],
    "assignment_page": 530,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab9d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "FIGURAS LITERARIAS",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-input1"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input2"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input3"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-input4"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input5"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input6"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-input7"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input8"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input9"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-input10"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input11"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input12"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-input13"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input14"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input15"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-input16"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input17"
      },
      {
        "placeholder": "1-2 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "figuras-input18"
      }
    ],
    "label_position": [
      {
        "placeholder": "Figura",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-column-title-1"
      },
      {
        "placeholder": "Ejemplo del texto",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-column-title-2"
      },
      {
        "placeholder": "Interpretación",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "figuras-column-title-3"
      }
    ],
    "assignment_page": 531,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab10d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "INGRESO DE PALABRAS NUEVAS",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input1"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input2"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input3"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input4"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input5"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input6"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input7"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input8"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input9"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input10"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input11"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input12"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input13"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input14"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input15"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input16"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input17"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input18"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input19"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input20"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input21"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input22"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input23"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input24"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input25"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input26"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input27"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input28"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input29"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input30"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input31"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input32"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input33"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input34"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input35"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input36"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input37"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input38"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input39"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input40"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input41"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input42"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input43"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input44"
      },
      {
        "placeholder": "1 sentences",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input45"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input46"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input47"
      },
      {
        "placeholder": "2-3 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "ingreso-input48"
      }
    ],
    "label_position": [
      {
        "placeholder": "Palabra",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "ingreso-column-title-1",
      },
      {
        "placeholder": "Tipo de palabra",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "ingreso-column-title-2"
      },
      {
        "placeholder": "Definición",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "ingreso-column-title-3"
      },
      {
        "placeholder": "Sinónimo",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "ingreso-column-title-4"
      },
      {
        "placeholder": "Antónimo",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "ingreso-column-title-5"
      },
      {
        "placeholder": "Traducción",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "ingreso-column-title-6"
      },
    ],
    "assignment_page": 532,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab11d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "INTERCONECTADOS",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 sentece ",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interconectados-input1"
      },
      {
        "placeholder": "1 sentece ",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interconectados-input2"
      },
      {
        "placeholder": "1 sentece ",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interconectados-input3"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interconectados-input4"
      }
    ],
    "label_position": [
      {
        "placeholder": "short 3-5 line instruction",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interconectadosInstruction"
      },
      {
        "placeholder": "Palabra",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interconectados-circle-title-1"
      },
      {
        "placeholder": "Efecto personal",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interconectados-circle-title-2"
      },
      {
        "placeholder": "Efecto social",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interconectados-circle-title-3"
      },
      {
        "placeholder": "Efecto global",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interconectados-circle-title-4"
      },
    ],
    "assignment_page": 533,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab12d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "INTERPRETACIÓN POÉTICA",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "2-3 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interpretacion1"
      },
      {
        "placeholder": "2-3 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interpretacion2"
      },
      {
        "placeholder": "2-3 sentences",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interpretacion3"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Vas a leer un poema tres veces. Llena la plantilla con lo que vas comprendiendo y descubriendo del poema.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interpretacionInstruction"
      },
      {
        "placeholder": "Primero aprendi que:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interpretacion-title-1"
      },
      {
        "placeholder": "Despues entendi que:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interpretacion-title-2"
      },
      {
        "placeholder": "AL final me di cuenta que:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interpretacion-title-3"
      },
    ],
    "assignment_page": 534,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab13d",
    "bookId": 7,
    "chapter": 7,
    "displayName": "INTERROGANTES",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interrogantes1"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interrogantes2"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interrogantes3"
      },
      {
        "placeholder": "1 phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interrogantes4"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interrogantes5"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interrogantes6"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Después de haber leído el cuento llena la plantilla con detalles que presenten un resumen del conflicto del cuento. Recuerda que existen los conflictos internos y externos y que siempre cada cuento tiene un conflicto principal.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "interrogantesInstruction"
      },
      {
        "placeholder": "¿ Qué ?",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interrogantes-title-1"
      },
      {
        "placeholder": "¿ Quién ?",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interrogantes-title-2"
      },
      {
        "placeholder": "¿ Dondé ?",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interrogantes-title-3"
      },
      {
        "placeholder": "¿ Como ?",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interrogantes-title-4"
      },
      {
        "placeholder": "¿ Por qué ?",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interrogantes-title-5"
      },
      {
        "placeholder": "TEMA",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "interrogantes-phrase-title-6"
      },

    ],
    "assignment_page": 535,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5e",
    "bookId": 7,
    "chapter": 7,
    "displayName": "Mis tres ejemplos.",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "1. "
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "width": "0.305",
        "left": "0.35",
        "top": "0.40",
        "height": "0.14",
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "",
        "bottom_border": false
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Dibuja un retrato del personaje basándote en lo que has leído. En la parte de atrás de tu hoja dibuja símbolos y escribe palabras clave que cruzan la mente del personaje. No olvides escribir su nombre",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "misTresEjemplosInstruction",
      }
    ],
    "assignment_page": 536,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5f",
    "bookId": 7,
    "chapter": 7,
    "displayName": "PALABRAS VALIOSAS",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input1"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input2"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input3"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input4"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input5"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input6"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input7"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input8"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input9"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input10"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input11"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input12"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input13"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input14"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input15"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input16"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input17"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input18"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input19"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input20"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input21"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input22"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input23"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input24"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input25"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input26"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input27"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input28"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input29"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input30"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input31"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input32"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input33"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input34"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input35"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input36"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input37"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input38"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-input39"
      },
      {
        "placeholder": "1 Sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabras-input40"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Con las palabras presentadas llena este gráfico e investiga lo que se te pide.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "palabrasInstruction"
      },
      {
        "placeholder": "Palabra",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-column-title-1"
      },
      {
        "placeholder": "Definicion",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-column-title-2"
      },
      {
        "placeholder": "Sinonimo",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-column-title-3"
      },
      {
        "placeholder": "Antonimo",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-column-title-4"
      },
      {
        "placeholder": "Mi oracion",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "palabras-column-title-5"
      },
    ],
    "assignment_page": 537,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5g",
    "bookId": 7,
    "chapter": 7,
    "displayName": "PREDICCIONES",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 image",
        "input_type": "image",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input1"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input2"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input3"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input4"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input5"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input6"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input7"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input8"
      },
      {
        "placeholder": "1 short phrase",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "predicciones-input9"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Dibuja dentro del espacio lo que crees que ocurrirá en el texto. Escribe en la parte de abajo tus predicciones.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "prediccionesInstruction"
      }
    ],
    "assignment_page": 538,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5h",
    "bookId": 7,
    "chapter": 7,
    "displayName": "RESUMEN DE TEXTO EXPOSITIVO",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "resumenExpositivo1"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "resumenExpositivo2"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "resumenExpositivo3"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Escribe un resumen de un texto expositivo. Recuerda que en el resumen se habla del tema, también se presentan los hechos y detalles que apoyan la tesis o el propósito del autor que es explícita.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "resumenExpositivoInstruction"
      },
      {
        "placeholder": "Tema/idea principal:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "resumenExpositivo-title-1"
      },
      {
        "placeholder": "Hechos y detalles:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "resumenExpositivo-title-2"
      },
      {
        "placeholder": "Tesis (El proposito del autor es explicito):",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "resumenExpositivo-title-3"
      }
    ],
    "assignment_page": 539,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5i",
    "bookId": 7,
    "chapter": 7,
    "displayName": "RESUMEN DE TEXTO NARRATIVO",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",

    "input_position": [
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "rusemenNarrativo1"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "rusemenNarrativo2"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "rusemenNarrativo3"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Escribe un resumen de un texto narrativo. Recuerda que en el resumen se habla de la trama (personaje, ambiente, conflictos, etc.), también se presenta la secuencia de eventos y por último se expone el mensaje o propósito del autor que es casi siempre implícito",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "rusemenNarrativoInstruction"
      },
      {
        "placeholder": "Trama:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "rusemenNarrativo-title-1"
      },
      {
        "placeholder": "Argumento:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "rusemenNarrativo-title-2"
      },
      {
        "placeholder": "Tema y subtemas (implicitos):",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "rusemenNarrativo-title-3"
      }

    ],
    "assignment_page": 540,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5j",
    "bookId": 7,
    "chapter": 7,
    "displayName": "SEMEJANZAS, DIFERENCIAS, CONCLUSIONES",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasOne-input1"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasTwo-input2"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasThree-input3"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasFour-input4"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasFive-input5"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasSix-input6"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasSeven-input7"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasEight-input8"
      },
      {
        "placeholder": "1 bullet point",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasNine-input9"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Al leer los dos textos ya has entendido las semejanzas y diferencias entre ambos. Escríbelas en el organizador y saca tus conclusiones acerca de lo entendido",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "semejanzasInstruction"
      },
      {
        "placeholder": "Semejanzas",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "semejanzas-title-1"
      },
      {
        "placeholder": "Deferencias",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "semejanzas-title-2"
      },
      {
        "placeholder": "Conclusiones",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "semejanzas-title-3"
      }
    ],
    "assignment_page": 541,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5k",
    "bookId": 7,
    "chapter": 7,
    "displayName": "SOY BILINGÜE",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input1"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input2"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input3"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input4"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input5"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input6"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input7"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input8"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input9"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input10"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input11"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input12"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input13"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input14"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input15"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input16"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input17"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input18"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "soy-input19"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soy-input20"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Vamos a hacer comparaciones con las palabras que estamos aprendiendo en inglés y español.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soyBilingualInstruction"
      },
      {
        "placeholder": "Palabra en espanol",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soyBilingual-column-title-1"
      },
      {
        "placeholder": "Oracion en espanol",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soyBilingual-column-title-2"
      },
      {
        "placeholder": "Palabra en ingles",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soyBilingual-column-title-3"
      },
      {
        "placeholder": "Oracion en ingles",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "soyBilingual-column-title-4"
      }
    ],
    "assignment_page": 542,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5l",
    "bookId": 7,
    "chapter": 7,
    "displayName": "UNA ES SUFICIENTE",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input1"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input2"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input3"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input4"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input5"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input6"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input7"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input8"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "una-input9"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "una-input10"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Al terminar de leer tu texto vas a sintetizar la información de TODO un párrafo en una palabra clave. Harás esto con todos los párrafos. Al final deberás unir las palabras para escribir de una a tres oraciones resumiendo el texto leído. Piensa muy bien en la palabra a elegir, ya que tu resumen al final debe de tener sentido.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "unaInstruction",
      }
    ],
    "assignment_page": 543,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5m",
    "bookId": 7,
    "chapter": 7,
    "displayName": "VIÑETAS DEL CUENTO",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "vinetasCuento1"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "vinetasCuento2"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "vinetasCuento3"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "vinetasCuento4"
      },
      {
        "placeholder": "1 short paragraph",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "vinetasCuento5"
      }
    ],
    "assignment_page": 544,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeab5n",
    "bookId": 7,
    "chapter": 7,
    "displayName": "¿Y  EL TONO?",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1- 2 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tono-input1"
      },
      {
        "placeholder": "1- 2 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tono-input2"
      },
      {
        "placeholder": "1- 2 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tono-input3"
      },
      {
        "placeholder": "1- 2 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tono-input4"
      },
      {
        "placeholder": "1- 2 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tono-input5"
      },
      {
        "placeholder": "1- 2 words",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tono-input6"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "tono-input7"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "tono-input8"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "tono-input9"
      },
      {
        "placeholder": "1 words",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "tono-input10"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Escribe palabras que presenten implícita o explícitamente el tono del cuento. Después, al pie de la plantilla escribe tres posibles tonos según tus deducciones.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "tonoInstruction",
      }
    ],
    "assignment_page": 545,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484aeg1",
    "bookId": 7,
    "chapter": 7,
    "displayName": "T- CHART",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "t-chart-1"
      },
      {
        "placeholder": "1 word",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "t-chart-2"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "t-chart-3"
      },
      {
        "placeholder": "1 sentence",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "t-chart-4"
      }
    ],
    "label_position": [
      {
        "placeholder": "Instrucciones: Llena la información que se te pide según los temas presentados por tu maestro.",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "t-chartInstruction",
      },
    ],
    "assignment_page": 546,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  },
  {
    "id": "052d1554-9abf-4c43-b48e-1b6484wert",
    "bookId": 7,
    "chapter": 7,
    "displayName": "CORNELL NOTES",
    "page": null,
    "typeId": "activity",
    "questions": [
      {
        "type": "essay",
        "id": 1,
        "question": "q1"
      }
    ],
    "colorCode": null,
    "bookDescription": null,
    "redirectTo": null,
    "level": null,
    "type": null,
    "createdBy": "system",
    "cloneId": null,
    "category": null,
    "linked_to": [],
    "share_list": null,
    "share_by": null,
    "language_feedback": "SPANISH",
    "activity_type": "graphic_organizer",
    "input_position": [
      {
        "placeholder": "Tema/objetivo",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "cornell-input1"
      },
      {
        "placeholder": "Nombre",
        "input_type": "text",
        "text_length": "single_line",
        "bottom_border": false,
        "class_name": "cornell-input2"
      },
      {
        "placeholder": "Clase/Periodo",
        "input_type": "text",
        "text_length": "single_line",
        "bottom_border": false,
        "class_name": "cornell-input3"
      },
      {
        "placeholder": "Fecha",
        "input_type": "text",
        "text_length": "single_line",
        "bottom_border": false,
        "class_name": "cornell-input4"
      },
      {
        "placeholder": "Pregunta esencial",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "cornell-input5"
      },
      {
        "placeholder": "Preguntas",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "cornell-input6"
      },
      {
        "placeholder": "Notas",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "cornell-input7"
      },
      {
        "placeholder": "Resumen",
        "input_type": "text",
        "text_length": "multi_line",
        "bottom_border": false,
        "class_name": "cornell-input8"
      }
    ],
    "label_position": [
      {
        "placeholder": "Tema/objetivo:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-1",
      },
      {
        "placeholder": "Nombre:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-2",
      },
      {
        "placeholder": "Clase/Periodo:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-3",
      },
      {
        "placeholder": "Fecha:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-4",
      },
      {
        "placeholder": "Pregunta esencial:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-5",
      },
      {
        "placeholder": "Preguntas:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-6",
      },
      {
        "placeholder": "Notas:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-7",
      },
      {
        "placeholder": "Resumen:",
        "input_type": "text",
        "text_length": "one_line",
        "bottom_border": false,
        "class_name": "cornell-title-8",
      },
    ],
    "assignment_page": 547,
    "assignment_level": null,
    "copy_of": {
      "id": "",
      "title": ""
    },
    "is_exam": false,
    "is_ai": false,
    "is_unit_exam": false,
    "unit": null,
    "unit_exam": null,
    "ai_grading_config": {},
    "rubrics_id": null,
    "storyInstruction": null,
    "order_id": 0,
    "article_level_id": null,
    "sequence_order": null
  }
]